import React from 'react';
import Status, {
  TextItem
} from '~/App/shared/components/ProductCard/components/Status';

export interface AuctionStatusProps {
  items: TextItem[];
}

const AuctionStatusForCard = ({ items }: AuctionStatusProps) => {
  return (
    <div>
      {items.map(item => (
        <Status
          key={item.label}
          color={item.color}
          icon={item.icon}
          label={item.label}
        />
      ))}
    </div>
  );
};

export default AuctionStatusForCard;
